import { render, staticRenderFns } from "./FootagesDialog.vue?vue&type=template&id=01ae605a"
import script from "./FootagesDialog.vue?vue&type=script&lang=js"
export * from "./FootagesDialog.vue?vue&type=script&lang=js"
import style0 from "./FootagesDialog.vue?vue&type=style&index=0&id=01ae605a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports